import { SharedConstants } from "../../../../../shared/constants/shared.constants";
export class CreateApplicationDetailsBpiConstants {
    static STEP_TITLE = "Details";
    static DETAILS_FORM_GROUP_NAME = "detailsForm";
    static DESCRIPTION_LABEL = "Description";
    static BPAMS_REFERENCE_NUMBER_LABEL = "Reference number?";
    static HAS_BPAMS_REFERENCE_NUMBER_LABEL = "Do you have a building plan reference number?";
    static VERIFY_LABEL = "Verify";
    static DESCRIPTION_FORM_CONTROL_NAME = "description";
    static BPAMS_REFERENCE_NUMBER_FORM_CONTROL_NAME = "bpamsReferenceNumber";
    static HAS_BPAMS_REFERENCE_NUMBER_FORM_CONTROL_NAME = "hasBpamsReferenceNumber";
    static BPAMS_APPLICATION_ID_FORM_CONTROL_NAME = "bpamsApplicationId";
    static IS_VERIFIED_FORM_CONTROL_NAME = "isVerified";
    static APPLICANT_FORM_CONTROL_NAME = "applicantRecipient";
    static APPLICANT_AGENT_FORM_CONTROL_NAME = "applicantAgentRecipient";
    static MARK_APPLICANT_AGENT_NA_FORM_CONTROL_NAME = "markApplicantAgentAsNotApplicable";
    static PROPERTIES_FORM_CONTROL_NAME = "properties";
    static CENTROID_FORM_CONTROL_NAME = "centroid";
    static OWNERS_FORM_CONTROL_NAME = "owners";
    static VERIFICATION_MESSAGE = "Reference number verification successful";
    static MISSING_REFERENCE_NUMBER = "Building plan reference number " + SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION;
    static APPLICANT_FORM_NAME = "applicantForm";
    static PROPERTY_FORM_NAME = "propertiesForm";
    static APPLICATION_TYPE_FROM_CONTROL_NAME = "applicationType";
    static VALIDATION_MESSAGES = {
        description: {
            required: `Description ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        hasBpamsReferenceNumber: {
            required: `Has building plans reference number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        },
        bpamsReferenceNumber: {
            required: `Building plans reference number ${SharedConstants.REQUIRED_INPUT_CONTROL_VALIDATION}`
        }
    };
}
